import React from 'react'

const NextArror = ({ color = '#f60' }) => {
  return (
    <div>
      <svg
        data-name="next-svgrepo-com (2)"
        xmlns="http://www.w3.org/2000/svg"
        width="20.32"
        height="20.32"
        viewBox="0 0 20.32 20.32"
      >
        <g data-name="Group 1212">
          <g data-name="Group 1211">
            <path
              data-name="Path 922"
              d="M20.32 10.16a10.16 10.16 0 1 0-10.16 10.16 10.171 10.171 0 0 0 10.16-10.16zm-18.9 0a8.738 8.738 0 1 1 8.74 8.74 8.746 8.746 0 0 1-8.738-8.74z"
              style={{ fill: color }}
            />
            <path
              data-name="Path 923"
              d="m205.081 158.973-2.99-2.99a.713.713 0 0 0-1.008 1.008l2.488 2.488-2.488 2.488a.711.711 0 1 0 1 1.008l2.99-2.99a.715.715 0 0 0 .008-1.012z"
              transform="translate(-192.545 -149.315)"
              style={{ fill: color }}
            />
          </g>
        </g>
      </svg>
    </div>
  )
}

export default NextArror
